module.exports = __webpack_public_path__ + "assets/webgl/card_069_EN_L0.jpg.ae235ea5.webp";